// Google Analytics 4 — provider-agnostic, off-by-default.
//
// This intentionally does NOT ship a real measurement ID. It reads
// REACT_APP_GA_MEASUREMENT_ID from the build environment; until that's set
// to a real "G-XXXXXXXXXX" ID, initAnalytics()/trackPageview() are no-ops —
// no script is injected, no network request is made, nothing changes for
// visitors. Set REACT_APP_GA_MEASUREMENT_ID in frontend/.env(.production)
// once a real GA4 property exists, then rebuild — no code change needed.
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

let initialized = false;

export function isAnalyticsEnabled() {
  return Boolean(GA_MEASUREMENT_ID);
}

export function initAnalytics() {
  if (!GA_MEASUREMENT_ID || initialized) return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  // send_page_view is handled manually via trackPageview() below so React
  // Router route changes (which don't reload the page) are tracked too.
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageview(path) {
  if (!GA_MEASUREMENT_ID || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
